module.exports = __webpack_public_path__ + "img/35.ed2fb3ef.jpg";